import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { IcChartPie, FaIcon } from "../../Icons";

// ── Reportes agrupados por sección ───────────────────────────────────────────
const SECCIONES = [
  {
    titulo: "Balances",
    icon:   "fas fa-balance-scale",
    color:  "#f59e0b",
    items: [
      {
        label: "Balance Mensual",
        icon:  "fas fa-table",
        color: "#f59e0b",
        bg:    "#fffbeb",
        href:  "/BalanceMensual",
        desc:  "Venta, gastos y cobranza por mes",
      },
      {
        label: "Balance Mensual V2",
        icon:  "fas fa-balance-scale",
        color: "#8b5cf6",
        bg:    "#f5f3ff",
        href:  "/BalanceMensualV2",
        desc:  "MRR, anualidades normalizadas y reparto de retiro",
      },
      {
        label: "Balance Anual",
        icon:  "fas fa-calendar-check",
        color: "#0ea5e9",
        bg:    "#f0f9ff",
        href:  "/BalanceAnual",
        desc:  "Comparativo histórico por año",
      },
    ],
  },
  {
    titulo: "Ventas",
    icon:   "fas fa-chart-bar",
    color:  "#3b82f6",
    items: [
      {
        label: "Venta Mensual",
        icon:  "fas fa-chart-bar",
        color: "#3b82f6",
        bg:    "#eff6ff",
        href:  "/GraficaVentasMensual",
        desc:  "Ingresos por mes en un período",
      },
      {
        label: "Venta Anual",
        icon:  "fas fa-chart-column",
        color: "#6366f1",
        bg:    "#eef2ff",
        href:  "/GraficaVentasAnual",
        desc:  "Comparativo de ingresos por año",
      },
      {
        label: "Venta Comparativa",
        icon:  "fas fa-chart-line",
        color: "#8b5cf6",
        bg:    "#f5f3ff",
        href:  "/GraficaVentasComparativa",
        desc:  "Mes a mes: año actual vs anterior",
      },
    ],
  },
  {
    titulo: "Cargos y Cobranza",
    icon:   "fas fa-file-invoice-dollar",
    color:  "#10b981",
    items: [
      {
        label: "Cobranza Mensual",
        icon:  "fas fa-hand-holding-usd",
        color: "#10b981",
        bg:    "#f0fdf4",
        href:  "/GraficaAbonosMensual",
        desc:  "Abonos cobrados por mes",
      },
      {
        label: "Reporte Cargos",
        icon:  "fas fa-chart-pie",
        color: "#3b82f6",
        bg:    "#eff6ff",
        href:  "/ReporteCargos",
        desc:  "Distribución y cobranza por categoría",
      },
    ],
  },
  {
    titulo: "Clientes",
    icon:   "fas fa-users",
    color:  "#8b5cf6",
    items: [
      {
        label: "Clientes Activos",
        icon:  "fas fa-users",
        color: "#8b5cf6",
        bg:    "#f5f3ff",
        href:  "/ClientesActivos",
        desc:  "Activos por año de alta y por ramo",
      },
    ],
  },
];

// ── Componente de tarjeta ────────────────────────────────────────────────────
function ReporteCard({ r }) {
  return (
    <a
      href={r.href}
      style={{
        display:        "flex",
        flexDirection:  "column",
        alignItems:     "center",
        gap:            10,
        padding:        "22px 14px",
        background:     "#fff",
        borderRadius:   10,
        boxShadow:      "0 1px 3px rgba(0,0,0,0.07)",
        border:         "1px solid #f1f5f9",
        textDecoration: "none",
        color:          "#334155",
        transition:     "box-shadow 0.15s, transform 0.15s",
        textAlign:      "center",
        height:         "100%",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.10)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.07)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{
        width:          52,
        height:         52,
        borderRadius:   12,
        background:     r.bg,
        display:        "flex",
        alignItems:     "center",
        justifyContent: "center",
        flexShrink:     0,
      }}>
        <FaIcon cls={r.icon} size={22} style={{ color: r.color }} />
      </div>
      <div>
        <div style={{ fontWeight: 600, fontSize: "0.82rem", marginBottom: 2 }}>{r.label}</div>
        <div style={{ fontSize: "0.7rem", color: "#94a3b8", lineHeight: 1.3 }}>{r.desc}</div>
      </div>
    </a>
  );
}

// ── Vista principal ──────────────────────────────────────────────────────────
function BotonesReportes() {
  const { user } = useContext(AuthContext);

  return (
    <>
      <Header />
      <div className="card container col-12" style={{ padding: "20px 24px" }}>

        {/* Encabezado */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 8, background: "#f8fafc",
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "1px solid #e2e8f0",
          }}>
            <IcChartPie style={{ color: "#64748b", fontSize: "1rem" }} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
              Reportes
            </h3>
            <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
              Análisis y gráficas del negocio
            </p>
          </div>
        </div>

        {user.usuarios_permisos ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
            {SECCIONES.map((sec) => (
              <div key={sec.titulo}>

                {/* Título de sección */}
                <div style={{
                  display: "flex", alignItems: "center", gap: 8,
                  marginBottom: 14, paddingBottom: 8,
                  borderBottom: `2px solid ${sec.color}22`,
                }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: 6,
                    background: `${sec.color}18`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <FaIcon cls={sec.icon} size={14} style={{ color: sec.color }} />
                  </div>
                  <span style={{
                    fontWeight: 700, fontSize: "0.78rem", color: "#475569",
                    textTransform: "uppercase", letterSpacing: "0.07em",
                  }}>
                    {sec.titulo}
                  </span>
                  <div style={{ flexGrow: 1, height: 1, background: `${sec.color}18`, marginLeft: 4 }} />
                </div>

                {/* Tarjetas de la sección */}
                <div className="row">
                  {sec.items.map((r) => (
                    <div key={r.href} className="col-6 col-md-4 col-xl-3 mb-3">
                      <ReporteCard r={r} />
                    </div>
                  ))}
                </div>

              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso a reportes.</p>
        )}

      </div>
    </>
  );
}

export default BotonesReportes;
